validEmail = (email)-> /\S+@\S+\.\S+/.test email

empty = (string)->
    return true if string is null
    return false if typeof string isnt 'string'
    for i in [0...string.length]
        return false if string.charCodeAt(i) not in [32, 10]
    true

@makeApp = (captcha, stations)-> new Vue
    el: "#main-form"

    data:
        captcha:    captcha
        stations:   stations
        counties:   Object.keys stations
        answer:     '' # captcha answer
        anonymous:  '' # 'yes'|'no'
        submitted:  false
        submitting: false
        consent:    false
        wrongCaptcha: false

        cpPopupShown:     false # cp definition popup
        ppPopupShown:     false # privacy policy popup
        ncPopupShown:     false # iia faq popup
        imPopupShown:     false # im/chat disclaimer popup

        imPopupShownAlready: false

        form:
            resourceType: '' #website|chat/im|gaming|email|query see rt struct in labels.coffee
            suspicion:    '' #CP|CG|FS|RX|QU|IA declared in labels.coffee
            url:          ''
            referrer:     '' #referrer url
            comments:     ''
            details:      ''
            perpUsername: ''
            perpMobile:   ''
            fname:        ''
            lname:        ''
            email:        ''
            phone:        ''

        questions: aq # sequence of IA questions to ask user

        iaForm: # optional IA related fields that do not need questions
            gardaCaseId:    '' # optional garda case id from nc form flow
            dob:            '' # <18yo
            county:         '' # <18yo
            station:        '' # <18yo
            preferredMeans: '' # >18yo
            preferredTime:  '' # >18yo
            pgDetails: # parent or guardian details, <18yo
                fname: ''
                lname: ''
                email: ''
                phone: ''

        y: 'yes'
        n: 'no'
        rt: rt

    watch:
        "form.suspicion": (val)->
            @clearExcept ['suspicion'] if @form.resourceType
            @form.resourceType = rt.query if val is QU
            false

        "form.resourceType": (newVal)->
            if @form.url or @form.comments or @form.referrer
                @clearExcept ['suspicion', 'resourceType']
            return if @imPopupShownAlready
            if newVal is rt.chat
                @imPopupShown = @imPopupShownAlready = true

        anonymous: (val, oldVal)->
            if val is @y and oldVal is @n
                @consent = false
                @form[f] = '' for f in ['fname', 'lname', 'email', 'phone', 'county', 'station']

    computed:
        pgd: -> @iaForm.pgDetails

        isIA: -> @form.suspicion in [IA, SB]
        isCP: -> @form.suspicion is CP

        isOverageImagery:   -> @answerIs imageryTakenUnderage, overAgeImagery
        haveWeGardaConsent: -> @answerIs haveWeGardaConsent, gardaConsentGiven

        isUnderage: -> @isIA and     @answerIs ageNow, u18
        isOverage:  -> @isIA and not @answerIs ageNow, u18

        isNameCompulsory: -> @isIA and @haveWeGardaConsent

        isPG: -> @answerIs relationship, [guardianIncapable, guardianUnderage]

        dobLabel: -> if @isPG then "Date of Birth of Child" else "Date of Birth"

        isAnonymous: -> @anonymous is @y

        isQuery: -> @form.suspicion is QU

        contactsSet: ->
            return true if @isAnonymous
            hasEmail = validEmail @form.email
            if @isNameCompulsory
                fNameOk = @form.fname.trim().length > 2
                lNameOk = @form.lname.trim().length > 2
                return hasEmail and fNameOk and lNameOk
            if @isIA
                return hasEmail and @form.phone.length > 6
            hasEmail

        iaFilledOut: ->
            return true if not @isIA
            findDone = (q)->
                return true if q.done
                return false if not q.next
                findDone q.next
            findDone @questions[whoIsFeatured]

        canCaptcha: ->
            return true if @isAnonymous
            @contactsSet and @iaFilledOut and @consent

        showAnonymousOption: -> not (@isIA or @isQuery)

        urlFilledOut: ->
            if @form.resourceType in [rt.website, rt.email]
                return not empty @form.url
            return @form.url.length > 4

        step3done: ->
            validQuery = if @isQuery then @form.comments.length > 5 else true
            @urlFilledOut and validQuery

        captchaEntered: -> @answer.length is 2

        showContactFields: -> @step3done and @iaFilledOut

        preferEmail:
            get:    -> @iaForm.preferredMeans is preferEmail
            set: (v)-> @iaForm.preferredMeans =  preferEmail

        preferPhone:
            get:    -> @iaForm.preferredMeans is preferPhone
            set: (v)-> @iaForm.preferredMeans =  preferPhone

    methods:
        answerIs: (qLabel, aLabel)-> # aLabel is string|string[]
            a = @questions[qLabel].answer
            return false if not a
            if aLabel.constructor is String
                a.label is aLabel
            else a.label in aLabel

        checkOptionVisibility: (field)->
            return true if not field
            not @[field]

        clearExcept: (except = [])-> #clear form fields except those
            for field of @form when field not in except
                @form[field] = ''
            if @questions[imageryTakenUnderage].answer #clear the nc form if needed
                @questions[field].answer = '' for field of @questions

        caseIdShown: (q)-> (a = q.answer) and a.label is beenReported

        submit: ->
            @submitting = true
            ok = =>
                @submitted    = true
                @wrongCaptcha = false
            notok = (res)=>
                @answer       = ''
                @wrongCaptcha = true
                @captcha      = res.captcha
            done  = => @submitting = false
            if @isIA
                ia    = {}
                iaf   = @iaForm
                iagp  = iaf.pgDetails
                isDef = (val)-> if val then val else unspecified

                ia[gardaCaseId]    = iaf.gardaCaseId
                ia[victimDob]      = iaf.dob
                ia[gardaDistrict]  = iaf.county
                ia[gardaStation]   = iaf.station
                ia[preferredMeans] = isDef iaf.preferredMeans
                ia[preferredTime]  = iaf.preferredTime
                ia[pgFirstName]    = iagp.fname
                ia[pgLastName]     = iagp.lname
                ia[pgEmail]        = iagp.email
                ia[pgPhone]        = iagp.phone
                for qLabel, q of @questions when a = q.answer
                    ia[qLabel] = a.label
                @form.ia = ia
            api @answer, @form, ok, notok, done
            #api "submit/#{@answer}?XDEBUG_SESSION_START=START", @form, ok, notok, done

api = (answer, data, success, error, completed)-> ajax "/form/submit.php?answer=#{answer}", data, success, error, completed

ajax = (url, data, success, error, completed)->
    form = new FormData
    props = (prepend, val)->
        if typeof val isnt 'object'
            form.append prepend, val
        else for k,v of val
            props "#{prepend}[#{k}]", v
        form
    props k,v for k,v of data

    req = new XMLHttpRequest
    req.onreadystatechange =->
        if req.readyState == 4
            response = 'OK'
            if req.response and req.response isnt ''
                response = JSON.parse req.response
            if req.status isnt 200
                error response if error
            else
                console.log response
                success response if success
    req.onload = completed if completed
    req.open "POST", url
    req.send form
